<div class="order-receipt mt-4 desktop:mt-0">
  <div class="order-receipt__head grid grid-cols-3 desktop:grid-cols-receipt-items items-center border-b-2 border-dmp-gray mb-2 pb-2 text-receipt font-bold text-dmp-charcoal">
    <span>Your Items</span>
    <div class="hidden desktop:block"></div>
    <span class="hidden desktop:block">Quantity</span>
    <span class="hidden desktop:block">Price</span>
    <span class="hidden desktop:block">Item Total</span>
  </div>

  @for (item of order.orderItems; track $index) {
    <div class="order-receipt__item grid grid-cols-3 desktop:grid-cols-receipt-items items-center border-b-2 border-dmp-gray mb-2 pb-2 desktop:pb-0">
      <img class="w-16 desktop:w-24 mb-2" [src]="item.productImage" [alt]="item.productName">
      <div class="col-span-2 desktop:col-span-1">
        <p class="order-receipt__name font-bold max-w-64 m-0">{{ item.productName }}</p>
        <p class="order-receipt__order-id m-0">{{ order.name }}</p>
      </div>
      <div><span class="desktop:hidden block text-receipt font-bold text-dmp-charcoal mt-1">Quantity</span>{{ item.quantity }}</div>
      <div><span class="desktop:hidden block text-receipt font-bold text-dmp-charcoal mt-1">Price</span>{{ item.productPrice | currency: "USD":"symbol-narrow":".2-2" }}</div>
      <div><span class="desktop:hidden block text-receipt font-bold text-dmp-charcoal mt-1">Item Total</span>{{ item.totalPrice | currency: "USD":"symbol-narrow":".2-2" }}</div>
    </div>
  }
  @if (orderReceipt.upsells && orderReceipt.upsells.length) {
    @for (upsell of orderReceipt.upsells; track upsell.name) {
      @for (orderItem of upsell.orderItems; track $index) {
        <div class="order-receipt__item grid grid-cols-3 desktop:grid-cols-receipt-items items-center border-b-2 border-dmp-gray mb-2 pb-2 desktop:pb-0">
          <img class="w-16 desktop:w-24 mb-2" [src]="orderItem.productImage" [alt]="orderItem.productName">
          <div class="col-span-2 desktop:col-span-1">
            <p class="order-receipt__name font-bold max-w-64 m-0">{{ orderItem.productName }}</p>
            <p class="order-receipt__order-id m-0">{{ upsell.name }}</p>
          </div>
          <div><span class="desktop:hidden block text-receipt font-bold text-dmp-charcoal mt-1">Quantity</span>{{ orderItem.quantity }}</div>
          <div><span class="desktop:hidden block text-receipt font-bold text-dmp-charcoal mt-1">Price</span>{{ orderItem.productPrice | currency: "USD":"symbol-narrow":".2-2" }}</div>
          <div><span class="desktop:hidden block text-receipt font-bold text-dmp-charcoal mt-1">Item Total</span>{{ orderItem.totalPrice | currency: "USD":"symbol-narrow":".2-2" }}</div>
        </div>
      }
    }
  }

  <!-- Mobile: seal over guarantee on the left, totals on the right. Desktop: the item-row grid, so labels sit in the Price column and amounts in the Item Total column. -->
  <div class="order-receipt__footer grid grid-cols-2 desktop:grid-cols-receipt-items items-start mt-4 mb-2 desktop:mb-0">
    <img class="w-20 mb-2 desktop:mb-0" src="https://cdn.drmartypets.com/images/mbgSeal.png" alt="">
    <div class="order-receipt__guarantee col-start-1 desktop:col-start-2 desktop:col-span-2 desktop:row-start-1 text-10 desktop:text-receipt-fine">
      <p class="font-bold m-0">Our Happy-Healthy Guarantee</p>
      <p class="m-0 desktop:w-56">If you don't see improvements, send back your supply &amp; we'll refund 100% of your purchase price</p>
    </div>
    <dl class="order-receipt__totals col-start-2 row-start-1 row-span-2 desktop:col-start-4 desktop:col-span-2 desktop:row-span-1 grid grid-cols-receipt-totals desktop:grid-cols-subgrid gap-x-1 desktop:gap-x-0 text-right m-0">
      <dt class="desktop:text-left">Taxes:</dt>
      <dd class="summary-row tax mt-0 mb-2 ml-0 desktop:text-left">{{ order.tax + upsellsTotalTax | currency: "USD":"symbol-narrow":".2-2" }}</dd>
      <dt class="desktop:text-left">Shipping:</dt>
      <dd class="summary-row shipping mt-0 mb-2 ml-0 desktop:text-left">{{ order.orderShippingCost + upsellsShippingCost | currency: "USD":"symbol-narrow":".2-2" }}</dd>
      <dt class="font-bold text-dmp-green desktop:text-left">TOTAL:</dt>
      <dd class="summary-row total font-bold text-dmp-green mt-0 mb-2 ml-0 desktop:text-left">{{ order.total + upsellsTotal | currency: "USD":"symbol-narrow":".2-2" }}</dd>
    </dl>
  </div>
</div>
